module.exports = __webpack_public_path__ + "static/media/FTX.19c3e4fd.svg";